<template>
  <div>
    <SingleRideHeader />
    <b-container class="py-5">
      <SingleRideChecklist />
    </b-container>
    <Footer />
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'
import SingleRideChecklist from '@/components/SingleRideChecklist'
import SingleRideHeader from '@/components/SingleRideHeader';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RideChecklist',
  components: {
    SingleRideChecklist,
    Footer,
    SingleRideHeader
  },
  methods: mapActions(['rideUpdateMarkerByScrollerLocation']),
  created(){
    window.addEventListener('scroll', this.rideUpdateMarkerByScrollerLocation);
    const rideIdFromUrl = this.$route.params.id;
    if ( rideIdFromUrl ){
      this.$store.commit('setLowedRideId', rideIdFromUrl);
    }

  },
  mounted(){
    this.$store.commit('rideSetPresentedDay', null);
    // this.rideUpdateMarkerByScrollerLocation();
  },
  destroyed(){
    window.removeEventListener('scroll', this.rideUpdateMarkerByScrollerLocation);
  },

};


</script>